// extracted by mini-css-extract-plugin
module.exports = {"listingContainer":"style_listingContainer__fhEGG","doctorImage":"style_doctorImage__rtmHc","timeAndDoctor":"style_timeAndDoctor__L++2W"};